"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-fifteen/section/companySection.tsx */

import { SmartImage } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import Slider, { type Settings } from "react-slick";
import { FC, ComponentProps, Key, ReactNode } from "react";

type CompanySectionSlidesItem = {
    key: Key | null | undefined;
    /** Detected variants: "/Templates/Doccure/img/company/company-img-1.svg" | "/Templates/Doccure/img/company/company-img-2.svg" | "/Templates/Doccure/img/company/company-img-3.svg" | "/Templates/Doccure/img/company/company-img-4.svg" | "/Templates/Doccure/img/company/company-img-5.svg" | "/Templates/Doccure/img/company/company-img-6.svg" */
    src: string;
    /** Detected variants: "slide-item" */
    className?: string;
    /** Detected variants: "img" */
    alt?: string;
};
const settings: Settings = {
    dots: false,
    infinite: true,
    speed: 2000,
    slidesToShow: 6,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 0, // optional (see note below)
    arrows: false,
    responsive: [
        {
            breakpoint: 1400,
            settings: {
                slidesToShow: 6,
                slidesToScroll: 1,
            },
        },
        {
            breakpoint: 1200,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 1,
            },
        },
        {
            breakpoint: 992,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
            },
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
            },
        },
    ],
};

export type HomeFifteenCompanySectionGeneratedProps = {
    /** Default: "2s" */
    divDiv0Div0DivDataWowDuration?: string;
    /** Default: "Trusted By 5k+ Clients around the World" */
    divDiv0Div0Div0DivText?: ReactNode;
    /** Default: "2s" */
    divDiv0Div1Div0DivDataWowDuration?: string;
    divDiv0Div1Div0Slider0SliderProps?: Partial<ComponentProps<typeof Slider>>;
    /** Default: "shadow" */
    divDiv0Div1ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/shadow-1.png" */
    divDiv0Div1ImageWithBasePath0ImageSrc?: string;
    divDiv0Div1ImageWithBasePath0ImageVisible?: boolean;
    divDiv0Div1ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    divDiv0Div1ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "shadow" */
    divDiv0Div1ImageWithBasePath1ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/shadow-2.png" */
    divDiv0Div1ImageWithBasePath1ImageSrc?: string;
    divDiv0Div1ImageWithBasePath1ImageVisible?: boolean;
    divDiv0Div1ImageWithBasePath1ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    divDiv0Div1ImageWithBasePath1ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    divImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: CompanySectionSlidesItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    companySectionSlides: CompanySectionSlidesItem[];
    companySectionSlidesItemWrapper?: (item: CompanySectionSlidesItem, content: ReactNode) => ReactNode;
    companySectionSlidesRenderer?: (defaultNode: ReactNode) => ReactNode;
    companySectionSlidesImageVisible?: boolean;
    companySectionSlidesImageRenderer?: (item: CompanySectionSlidesItem, defaultNode: ReactNode) => ReactNode;
    companySectionSlidesImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: CompanySectionSlidesItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
};

const HomeFifteenCompanySectionGenerated: FC<HomeFifteenCompanySectionGeneratedProps> = ({
    divDiv0Div0Div0DivText = "Trusted By 5k+ Clients around the World",
    divDiv0Div0DivDataWowDuration = "2s",
    divDiv0Div1Div0DivDataWowDuration = "2s",
    divDiv0Div1ImageWithBasePath0ImageAlt = "shadow",
    divDiv0Div1ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/bg/shadow-1.png",
    divDiv0Div1ImageWithBasePath0ImageVisible,
    divDiv0Div1ImageWithBasePath0ImageRenderer,
    divDiv0Div1ImageWithBasePath0ImageProps,
    divDiv0Div1ImageWithBasePath1ImageAlt = "shadow",
    divDiv0Div1ImageWithBasePath1ImageSrc = "/Templates/Doccure/img/bg/shadow-2.png",
    divDiv0Div1ImageWithBasePath1ImageVisible,
    divDiv0Div1ImageWithBasePath1ImageRenderer,
    divDiv0Div1ImageWithBasePath1ImageProps,
    divDiv0Div1Div0Slider0SliderProps,
    divImageWithBasePath0ImageProps,
    companySectionSlides,
    companySectionSlidesItemWrapper,
    companySectionSlidesRenderer,
    companySectionSlidesImageVisible,
    companySectionSlidesImageRenderer,
    companySectionSlidesImageProps,
}) => {
    return (
        <div className="section company-section-fifteen pb-0">
            <div className="container">
                <div className="section-header-fifteen text-center wow fadeInUp" data-wow-duration={divDiv0Div0DivDataWowDuration}>
                    <div className="sub-title">{divDiv0Div0Div0DivText}</div>
                </div>
                <div className="container">
                    {renderNode(divDiv0Div1ImageWithBasePath0ImageVisible, divDiv0Div1ImageWithBasePath0ImageRenderer, (
                        <SmartImage src={divDiv0Div1ImageWithBasePath0ImageSrc} alt={divDiv0Div1ImageWithBasePath0ImageAlt} className="shadow-1" {...(divDiv0Div1ImageWithBasePath0ImageProps ?? {})} />
                    ))}
                    {renderNode(divDiv0Div1ImageWithBasePath1ImageVisible, divDiv0Div1ImageWithBasePath1ImageRenderer, (
                        <SmartImage src={divDiv0Div1ImageWithBasePath1ImageSrc} alt={divDiv0Div1ImageWithBasePath1ImageAlt} className="shadow-2" {...(divDiv0Div1ImageWithBasePath1ImageProps ?? {})} />
                    ))}
                    <div className="company-slider company-slider-fifteen wow fadeInUp" data-wow-duration={divDiv0Div1Div0DivDataWowDuration}>
                        <Slider {...settings} {...(divDiv0Div1Div0Slider0SliderProps ?? {})}>
                            {renderCollectionNode(
                                companySectionSlides,
                                (item: CompanySectionSlidesItem) => (
                                    <div className={item.className ?? "slide-item"} key={item.key}>
                                        {renderItemNode(companySectionSlidesImageVisible, companySectionSlidesImageRenderer, item, (
                                            <SmartImage src={item.src} alt={item.alt ?? "img"} {...(typeof companySectionSlidesImageProps === "function" ? companySectionSlidesImageProps(item) : (companySectionSlidesImageProps ?? {}))} {...(typeof divImageWithBasePath0ImageProps === "function" ? divImageWithBasePath0ImageProps(item) : (divImageWithBasePath0ImageProps ?? {}))} />
                                        ))}
                                    </div>
                                ),
                                companySectionSlidesItemWrapper,
                                companySectionSlidesRenderer
                            )}
                        </Slider>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HomeFifteenCompanySectionGenerated;
